import * as React from 'react';
const OverlayCore = (props) => {
    const { className, components, spinner } = props;
    const { Spinner } = components;
    const BEM = () => {
        const classArray = ['overlay'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getSpinner = () => {
        if (typeof spinner === 'object' && spinner !== null) {
            const spinnerBEM = () => {
                const classArray = ['overlay__spinner'];
                if (spinner.className) {
                    classArray.push(spinner.className);
                }
                return classArray.join(' ');
            };
            return React.createElement(Spinner, Object.assign({}, spinner, { className: spinnerBEM() }));
        }
        else if (spinner) {
            return React.createElement(Spinner, { className: "overlay__spinner" });
        }
    };
    return React.createElement("div", { className: BEM() }, getSpinner());
};
export { OverlayCore as default };
